<template>
    <div class="row p-3">
        <input-select class="col-12 col-md-4" label="TRL proposta" :options="options.trls" v-model="form.trlProposta" ref="trlProposta" :disabled="!controlesLiberados || !permissao.u"/>
        <input-select class="col-12 col-md-4" label="TRL execução" :options="options.trls" v-model="form.trlExecucao" ref="trlExecucao" :disabled="!controlesLiberados || !permissao.u"/>
        <input-select class="col-12 col-md-4" label="TRL final" :options="options.trls" v-model="form.trlFinal" ref="trlFinal" :disabled="!controlesLiberados || !permissao.u"/>
        <div class="col-12">
            <b-button variant="success" v-if="controlesLiberados && permissao.u" @click="salvar">
                <i class="fa-solid fa-check mr-2"></i>
                Salvar
            </b-button>
        </div>
    </div>
</template>
<script>
import InputSelect from "@/components/inputs/InputSelect.vue";
import ProjetoService from "@/common/services/projeto/projeto.service";
import helpers from "@/common/utils/helpers";
import {AlertasMixin} from "@/common/mixins/AlertasMixin";

export default {
    name: "Trl",
    mixins: [AlertasMixin],
    components: {
        InputSelect,
    },
    props: {
        projetoIdBase: {
            required: true,
        },
        projetoEditavel: {
            type: Boolean,
            default: false
        },
    },
    data: () => ({
        options: {
            trls: helpers.TRL,
        },
        form: {
            trlProposta: null,
            trlExecucao: null,
            trlFinal: null,
        }
    }),
    methods: {
        buscar: function(){
            ProjetoService.listarCaracteristicas('trl', this.projetoIdBase).then(response => {
                this.form = response.data.data || this.form;
            });
        },
        salvar: function(){
            this.confirmar("Deseja salvar?", "").then(confirmado => {
                if(confirmado){
                    this.form.ProjetoId = this.projetoIdBase;
                    ProjetoService.atualizarCaracteristicas('trl', this.form).then(() => {
                        this.alertaSucesso("Salvo com sucesso!");
                        this.buscar();
                        this.$emit('update');
                    }).catch(err => {
                        if(err.response.status == 400){
                            this.alertaErro(err.response.data.errors);
                        }else
                            this.alertaErro("Erro ao salvar");
                    });
                }
            });
        },
    },
    computed: {
        controlesLiberados: function(){
            return this.projetoEditavel
        },
        permissao() {
            return this.$store.getters['app/retornaPermissao']('ProjetosPdTRL');
        },
    },
    mounted: function(){
        this.buscar();
    }
}
</script>
<style lang="">

</style>
